// Environment variables validation and export
const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = process.env[key] || defaultValue;
  if (!value && !defaultValue) {
    console.warn(`Environment variable ${key} is not set`);
  }
  return value || "";
};

export const env = {
  // API
  REACT_APP_API_URL: getEnvVar("REACT_APP_API_URL"),
  REACT_APP_FMCG_LOGIN: getEnvVar("REACT_APP_FMCG_LOGIN"),
  
  // Firebase
  REACT_APP_FIREBASE_API_KEY: getEnvVar("REACT_APP_FIREBASE_API_KEY"),
  REACT_APP_AUTH_DOMAIN: getEnvVar("REACT_APP_AUTH_DOMAIN"),
  REACT_APP_PROJECT_ID: getEnvVar("REACT_APP_PROJECT_ID"),
  REACT_APP_MESSAGING_SEND_ID: getEnvVar("REACT_APP_MESSAGING_SEND_ID"),
  REACT_APP_APP_ID: getEnvVar("REACT_APP_APP_ID"),
  
  // Auth
  REACT_APP_ALLOWED_ROLE: getEnvVar("REACT_APP_ALLOWED_ROLE"),
  REACT_APP_IS_DEV: getEnvVar("REACT_APP_IS_DEV") === "true",
  
  // Node environment
  NODE_ENV: process.env.NODE_ENV || "development",
} as const;

export default env;
